import api from "./api";

const attendanceService = {
  getMarkingSheet: (params) => api.get("/attendance/marking-sheet", { params }),
  markAttendance: (data) => api.post("/attendance/mark", data),
  getReport: (params) => api.get("/attendance/report", { params }),
  getSubjectReport: (params) => api.get("/subject-attendance/report", { params }),
};

export default attendanceService;
